export default __webpack_public_path__ + "static/media/discord.a034c939.svg";